var con = require('./_content');
$(function () {
    var components = $('#components').val();
    if (components) {
        components = JSON.parse(components);
        con.setcontentinfo(components);
        var body = $('#contents').html();
        body = con.geteditorbody(body);
        $('#contents').html(body);

        for (var i = 0; i < $('.content-live').length; i++) {
            var id = $($('.content-live')[i]).attr('data-src');
            var urls = con.playlive(id);
            var playerid = 'player-live-' + id;
            $($('.content-live')[i]).html(
                '<video id="' +
                playerid +
                '" number="' +
                num++ +
                '" style="min-width: 800px; min-height: 640px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            // startPlay(play, { urls: urls, id: playerid });
            startPlay(urls[0], playerid);
            players.push(play);
        }
        for (var i = 0; i < $('.content-video').length; i++) {
            var id = $($('.content-video')[i]).attr('data-src');
            var urls = con.playvideo(id);
            if (!urls) continue;
            urls.sort(function(a, b) {
                if (a.substr(-5) == '.m3u8') return -1;
                else if (b.substr(-5) == '.m3u8') return 1;
                else return 0;
            });
            var playerid = 'player-video-' + id;
            $($('.content-video')[i]).html(
                '<video id="' +
                playerid +
                '" number="' +
                num++ +
                '" style="min-width: 800px; min-height: 640px;" class="video-js vjs-big-play-centered"></video>'
            );
            var ads = getVideoAds(id);
            var play;
            // startPlay(play, { urls: urls, id: playerid, ads: ads });
            startPlay(urls[0], playerid);
            players.push(play);
        }
        for (var i = 0; i < $('.content-audio').length; i++) {
            var id = $($('.content-audio')[i]).attr('data-src');
            var obj = con.playaudio(id);
            if (!obj) continue;
            var playerid = 'player-audio-' + id;
            $($('.content-audio')[i]).html(
                '<video id="' +
                playerid +
                '" number="' +
                num++ +
                '" style="width: 800px; height: 50px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            startPlay(obj.strAudioUrl, playerid);
            players.push(play);
        }
    }
})


//////////////////
// WEBPACK FOOTER
// ./home/client/js/lsapp.page.js
// module id = 23
// module chunks = 5